import { CommonModule } from '@angular/common';
import { Component, computed, effect, input, signal } from '@angular/core';
import {
  GcAccordionComponent,
  GcIconComponent,
  GcTextComponent,
} from '@ip-only/front-end-library';
import { SharedModule } from '../../../../../shared.module';
import { SelfInspectionCheckboxComponent } from '../../../../report-inputs/self-inspection-checkbox/self-inspection-checkbox.component';
import { SelfInspectionFileAndTextComponent } from '../../../../report-inputs/self-inspection-file-and-text/self-inspection-file-and-text.component';
import { SelfInspectionFilesComponent } from '../../../../report-inputs/self-inspection-files/self-inspection-files.component';
import { SelfInspectionListComponent } from '../../../../report-inputs/self-inspection-list/self-inspection-list.component';
import { SelfInspectionRadioButtonComponent } from '../../../../report-inputs/self-inspection-radio-button/self-inspection-radio-button.component';
import { SelfInspectionTextComponent } from '../../../../report-inputs/self-inspection-text/self-inspection-text.component';
import { RolloutProgressReportEntities } from '../../../../service/entities';
import { ReportGroupBaseComponent } from '../../../report-group-base/report-group-base.component';

@Component({
  selector: 'app-report-group-v2',
  imports: [
    CommonModule,
    SharedModule,
    GcAccordionComponent,
    GcIconComponent,
    GcTextComponent,
    SelfInspectionTextComponent,
    SelfInspectionRadioButtonComponent,
    SelfInspectionListComponent,
    SelfInspectionCheckboxComponent,
    SelfInspectionFilesComponent,
    SelfInspectionFileAndTextComponent,
  ],
  templateUrl: './report-group-v2.component.html',
  styleUrl: './report-group-v2.component.scss',
})
export class ReportGroupV2Component extends ReportGroupBaseComponent {
  inspectionReportGroup =
    input.required<RolloutProgressReportEntities.v3.InspectionReportGroup>();

  definitionTypes = RolloutProgressReportEntities.v3.DefinitionType;
  reportId: string = this.reportService.getStoredReportId();
  reportAnswers = signal<RolloutProgressReportEntities.v3.ReportAnswer[]>(
    {} as RolloutProgressReportEntities.v3.ReportAnswer[],
  );
  language = signal<string | null>(this.languageService.getStoredLanguage());

  reportGroup = computed(
    () => this.inspectionReportGroup().group.groupInfo.groupName,
  );
  isAllComplete = computed(
    () => this.inspectionReportGroup().group.groupStatus.isCompleted,
  );
  isDeviation = computed(() => {
    const deviationGroups = Object.values(
      RolloutProgressReportEntities.v3.DeviationGroups,
    ) as string[];
    return deviationGroups.includes(this.reportGroup());
  });
  accordionHeader = computed(() => {
    const group =
      this.inspectionReportGroup().group.groupInfo.groupNameTranslations[
        this.language() as keyof RolloutProgressReportEntities.v3.IdentifierObject
      ];
    if (this.isDeviation()) {
      return group;
    }
    const completedAmount =
      this.inspectionReportGroup().group.groupStatus.selfInspectionsDone;
    const totalAmount =
      this.inspectionReportGroup().group.groupStatus
        .totalAmountOfSelfInspections;

    return `${group} (${completedAmount}/${totalAmount})`;
  });
  expandAccordion = computed(() => {
    return (
      (!this.isDeviation() && !this.isAllComplete()) ||
      (this.isDeviation() && this.isAllComplete())
    );
  });

  constructor() {
    super();
    effect(() => {
      this.convertAnswers();
    });
  }

  convertAnswers = (): void => {
    const convertedAnswers = this.inspectionReportGroup().selfInspections.map(
      (inspections) => ({
        data: this.helperService.convertAnswerV2(
          inspections,
          this.language() as keyof RolloutProgressReportEntities.v3.IdentifierObject,
        ),
        wrapperData: this.helperService.createWrapperDataV2(
          inspections,
          this.language() as keyof RolloutProgressReportEntities.v3.IdentifierObject,
        ),
      }),
    );

    this.reportAnswers.set(convertedAnswers);
  };
}
